import { withWidth } from '@material-ui/core'
import classNames from 'classnames'
import { FC } from 'react'
import { getCurrentLanguage } from '../../../translations/i18n'
import { ApplicationCardProps } from './ApplicationCard'
import badgeStyles from './badgeStyles.module.css'

const GuarantorPossibleBadge: FC<ApplicationCardProps> = ({ t, width }) => {
  const languageIsEN = getCurrentLanguage() === 'en'
  const isMobileEn = languageIsEN && width === 'xs'
  return (
    <>
      {languageIsEN ? (
        <img
          src={`https://dwellet-email-assets.s3.eu-central-1.amazonaws.com/icons/new_badge+(1).png`}
          alt='Personal Guarantee Badge'
          height='100'
          className={classNames(
            badgeStyles.guarantorBadge,
            isMobileEn && badgeStyles.guarantorBadgeEnMobile
          )}
        />
      ) : (
        <img
          src={`https://dwellet-email-assets.s3.eu-central-1.amazonaws.com/icons/uusi_badge+(1).png`}
          alt='Personal Guarantee Badge'
          height='100'
          className={classNames(
            badgeStyles.guarantorBadge,
            isMobileEn && badgeStyles.guarantorBadgeEnMobile
          )}
        />
      )}
    </>
  )
}

export default withWidth()(GuarantorPossibleBadge)
